import React from 'react';

const ExtendSubscriptionModal = ({ subscription, extendMonths, actionLoading, onMonthsChange, onExtend, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h3 className="text-lg font-semibold mb-4">Extend Subscription</h3>
        <p className="text-gray-600 mb-4">
          Extend subscription for <strong>{subscription.customer_name || subscription.customerName}</strong>
        </p>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Number of Months to Extend
          </label>
          <select
            value={extendMonths}
            onChange={(e) => onMonthsChange(parseInt(e.target.value))}
            className="w-full border border-gray-300 rounded-md p-2"
          >
            <option value={1}>1 Month</option>
            <option value={3}>3 Months (Quarter)</option>
            <option value={6}>6 Months</option>
            <option value={12}>12 Months (Year)</option>
          </select>
        </div>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:text-gray-800"
            disabled={actionLoading}
          >
            Cancel
          </button>
          <button
            onClick={onExtend}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
            disabled={actionLoading}
          >
            {actionLoading ? 'Extending...' : 'Extend Subscription'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExtendSubscriptionModal;